const categoryCollator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

export function normalizeWorkerCategoryBase(name: string | null | undefined): string {
  if (!name) return 'Labour';
  const trimmed = String(name).replace(/\s+/g, ' ').trim();
  if (!trimmed) return 'Labour';
  const withoutSkill = trimmed
    .replace(/(?:\s*[-\u2010-\u2015_]\s*|\s+)?(?:semi[\s_-]*skilled|un[\s_-]*skilled|skilled)\s*$/i, '')
    .replace(/[\s_-]+$/, '')
    .trim();
  return withoutSkill || trimmed;
}

function normalizeDisplayName(name: string | null | undefined): string {
  return String(name ?? '').replace(/\s+/g, ' ').trim();
}

function skillRank(skillLevel: string | null | undefined, name: string): number {
  const skill = String(skillLevel ?? '').replace(/[\s_-]+/g, '').toUpperCase();
  if (skill === 'SKILLED') return 0;
  if (skill === 'SEMISKILLED') return 1;
  if (skill === 'UNSKILLED') return 2;

  const upperName = name.toUpperCase();
  if (upperName.includes('SEMI')) return 1;
  if (/UN[\s_-]*SKILLED|HELPER|LABOURER/.test(upperName)) return 2;
  if (upperName.includes('SKILLED')) return 0;
  return 3;
}

export function compareWorkerCategoryBases(a: string | null | undefined, b: string | null | undefined): number {
  return categoryCollator.compare(normalizeWorkerCategoryBase(a), normalizeWorkerCategoryBase(b));
}

export function sortWorkerCategoryEntries<T>(
  items: readonly T[],
  getName: (item: T) => string | null | undefined,
  getSkillLevel: (item: T) => string | null | undefined = (item) => (item as { skillLevel?: string | null }).skillLevel,
  getId: (item: T) => string | null | undefined = (item) => (item as { id?: string }).id,
): T[] {
  return [...items].sort((a, b) => {
    const nameA = normalizeDisplayName(getName(a));
    const nameB = normalizeDisplayName(getName(b));

    const baseOrder = compareWorkerCategoryBases(nameA, nameB);
    if (baseOrder !== 0) return baseOrder;

    const skillOrder = skillRank(getSkillLevel(a), nameA) - skillRank(getSkillLevel(b), nameB);
    if (skillOrder !== 0) return skillOrder;

    const nameOrder = categoryCollator.compare(nameA, nameB);
    if (nameOrder !== 0) return nameOrder;

    const idA = String(getId(a) ?? '');
    const idB = String(getId(b) ?? '');
    return idA < idB ? -1 : idA > idB ? 1 : 0;
  });
}
